// extracted by mini-css-extract-plugin
module.exports = {"clamped":"Answer_clamped__1sJ-7","link":"Answer_link__2_r--","wrapper":"Answer_wrapper__3sRuP"};